import { AnyAction } from 'redux';

import { EditorStyleguide } from 'craft/types';

import { SET_EDITOR_STYLEGUIDE } from './constants';

export type EditorStyleguideState = EditorStyleguide;

const initialState = {} as EditorStyleguideState;

export const styleguideReducer = (state = initialState, action: AnyAction) => {
  switch (action.type) {
    case SET_EDITOR_STYLEGUIDE:
      return { ...state, ...action.styleguide };

    default:
      return state;
  }
};
